import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TenantConfig, TenantConfigState } from './tenantConfigTypes';

const initialState: TenantConfigState = { loadingConfigs: [], values: {} };

const tenantConfigSlice = createSlice({
  name: 'tenantConfig',
  initialState,
  reducers: {
    updateTenantConfig(state, action: PayloadAction<TenantConfig>) {
      const config = action.payload;

      state.values = { ...state.values, ...config };
    },
    addLoadingConfigs(state, action: PayloadAction<string[]>) {
      state.loadingConfigs = [...state.loadingConfigs, ...action.payload];
    },
    removeLoadingConfigs(state, action: PayloadAction<string[]>) {
      state.loadingConfigs = state.loadingConfigs.filter(
        config => !action.payload.includes(config)
      );
    },
    clearTenantConfig() {
      return initialState;
    }
  }
});

export const tenantConfigReducer = tenantConfigSlice.reducer;
export const {
  updateTenantConfig,
  clearTenantConfig,
  addLoadingConfigs,
  removeLoadingConfigs
} = tenantConfigSlice.actions;
